import React from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Logo } from "../../../icons/logo.svg";

const HeaderLogo = ({ widthComp = "100%" }) => {
  const navigate = useNavigate();
  return (
    <div onClick={() => navigate("/")}>
      <Logo className="logo" style={{ width: widthComp }} />
    </div>
  );
};

export default HeaderLogo;
